import EmptyAnimation from '@assets/lottie/empty-box.json';
import { OrderEmptyStateWrapperProps } from '@/renderer/types/sales';
import React from 'react';
import { LottieAnimation } from '../common';

export const OrderEmptyStateWrapper: React.FC<OrderEmptyStateWrapperProps> = ({
  message = 'No order selected',
}) => {
  return (
    <div className="flex h-full items-center justify-center px-4 text-center text-sm italic text-gray-400">
      {/* Lottie empty animation */}
      <div className="w-full flex flex-col gap-2">
        <LottieAnimation animationData={EmptyAnimation} />
        {message}
      </div>
    </div>
  );
};
